/**
 * VP-231 — heuristic detection of a "YouTube thumbnail" intent in the graphics prompt.
 *
 * Word boundaries matter: the old inline `yt\s` pattern matched Polish words like
 * "zbyt"/"byt", and `miniatur(a|y|ę)` matched any miniature object — which
 * force-switched the user's chosen format to 16:9 on every Generate click.
 * Detection is only ever a SUGGESTION (never overrides the user's format choice).
 */
const YT_THUMBNAIL_PATTERN = /miniaturk|thumbnail|youtube|\byt\b/i;

export function looksLikeYtThumbnail(prompt: string): boolean {
  return YT_THUMBNAIL_PATTERN.test(prompt);
}
